import getDataFromNodes from './get-data-from-nodes';
import getGalleryItems from './get-gallery-items';

const getGalleryData = (elementId, breakpoint) => {
  const galleryItems = getGalleryItems(elementId);

  return getDataFromNodes(galleryItems, breakpoint);
};

export default getGalleryData;
